import { useCallback, useState, useEffect } from 'react';

import { LocalStorageKeys } from '@keaze/web/common/enums';
import { useLocalStorage } from '@keaze/web/hooks';


// interface monthlySpend {
//   monthlySpendValue: string | null
//       }
//       const [state, setState] = useState<monthlySpend>({
//         monthlySpendValue: "0"
//       });


// if (typeof window !== "undefined") {
//   const queryString = window.location.search;
//   const urlParams = new URLSearchParams(queryString);
//   const MonthlyCost = urlParams.get('MonthlyCost')
//   alert(MonthlyCost);
//   setState({ ...state, monthlySpendValue : MonthlyCost});

// }


  









type UseSortByExpected = {
  sortBy: string;
  onSortByChange: (value: string) => void;
};



type UseSortBy = () => UseSortByExpected;

export const useSortBy: UseSortBy = () => {
  const [homePageMax, sethomePageMax] = useState("")
const [defaultSortText, setdefaultSortBy] = useState("")

  useEffect(() => {
    let defaultText
    defaultText = localStorage.getItem("defaultText") || ""
    setdefaultSortBy(defaultText)
    let value
    value = localStorage.getItem("monthlyCost") || ""
    sethomePageMax(value)



  }, 
  

  
  [])

  let DEFAULT_SORT_BY

  {defaultSortText === null ? 
  DEFAULT_SORT_BY='monthly-spend' :
  DEFAULT_SORT_BY='recommended' 


}

  const [storedSortBy, setStoredSortBy] = useLocalStorage<string>(
    LocalStorageKeys.sortBy,
    DEFAULT_SORT_BY


  );
  const [sortBy, setSortBy] = useState<string>(storedSortBy);
  const handleSortByChange = useCallback(
    (value: string) => {
      setSortBy(value);
      setStoredSortBy(value);
    },
    [setStoredSortBy]
  );

  return {
    sortBy,
    onSortByChange: handleSortByChange,
    
  };
};
